import Disclaimer from "components/Disclaimer";
import SiteHeader from "components/SiteHeader";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    padding: 1rem;
`

const Content = styled.div`
    flex: 1 0 auto;
`

const Root = () => {
    return (
        <Container>
            <SiteHeader />
            <Content>
                <Outlet />
            </Content>
            <Disclaimer />
        </Container>
    )
}

export default Root;